exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-buy-tamplate{\n    padding: 2px;\n    margin-right: 16px;\n}", ""]);

